import { useEffect, FC } from 'react';

interface useScriptProps {
    url: string;
}

export const useScript: FC<useScriptProps> = ({ url }) => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;

        document.body.appendChild(script);
    }, [url]);

    return null;
};
